import { useQuery } from "@tanstack/react-query";
import * as LucideIcons from "lucide-react";
import ApiService from "@minohealth/common/services/ApiService";

export const BIO_TOOLS_QUERY_KEY = ["bio-tools"];

export function resolveToolIcon(iconName) {
  return LucideIcons[iconName] || LucideIcons.Wrench;
}

/**
 * The tools to list. An empty list from the server falls back to the built-in
 * list, because the section hides itself when it has no tools.
 */
export function toolsToShow(fetchedTools, builtInTools) {
  return fetchedTools?.length > 0 ? fetchedTools : builtInTools;
}

export function useBioTools(user) {
  return useQuery({
    queryKey: BIO_TOOLS_QUERY_KEY,
    queryFn: ({ signal }) =>
      ApiService(user.userToken)
        .GetTools({ signal })
        .then((res) => res.data.payload),
    enabled: Boolean(user?.userToken),
  });
}
